(function () {
  angular
    .module('specsguardApp')
    .directive('sgTemplateList', sgTemplateList);

  sgTemplateList.$inject = [];

  function sgTemplateList () {
    return {
      restrict: 'EA',
      templateUrl: 'app-legacy/components/sg-template-list/sg-template-list.html',
      controller: 'TemplateListCtrl',
    };
  }
})();
